var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > 0)?_c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.tableHeaders,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(item._id)}}},[_c('v-icon',[_vm._v("mdi-delete")])],1)]}}],null,true)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }